import React, {Component} from "react";
import {SortableTableHeader} from "../../components/table/sortable-table-header";

export default class CaseTableHeader extends Component {

  static Layout = [
    { column: "queryKey", name: "Case Number" },
    { column: "status", width: 2 },
    { column: "queryType", width: 2, name: "Type"},
    { column: "caseCategory", width: 2, name: "Category"},
    { column: "description", width: 2 },
    { column: "dateLogged", width: 2, name: "Logged Date" },
    { column: "dateCompleted", width: 2, name: "Completed Date" },

    { column: "empty", width: 2 }
  ];

  render() {
    return (
        <SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={CaseTableHeader.Layout}/>
    )
  }
}